<div class="datepicker-month-year">
  <mat-form-field appearance="fill" class="datepicker">
    <mat-label>{{ label | i18next }}</mat-label>
    <input
      matInput
      [id]="id"
      placeholder="{{ placeholder | i18next }}"
      [ngClass]="{ error: hasError }"
      [attr.aria-required]="isRequired"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="errorId"
      [(ngModel)]="value"
      (blur)="markAsTouched()"
      [matDatepicker]="picker"
      [min]="minDate"
    />

    <mat-datepicker-toggle matSuffix [for]="picker">
      <i
        class="fa fa-chevron-down"
        matDatepickerToggleIcon
        aria-hidden="true"
      ></i>
    </mat-datepicker-toggle>
    <mat-datepicker
      #picker
      startView="multi-year"
      (monthSelected)="setMonthAndYear($event, picker)"
    ></mat-datepicker>
  </mat-form-field>
  <i class="fa fa-exclamation-triangle" aria-hidden="true" *ngIf="hasError">
  </i>
  <div class="errorLabel">
    <span class="app-error-text" [id]="errorId">
      {{ hasError ? (errorText | i18next) : '' }}
    </span>
  </div>
</div>
